import { useQuery } from "react-query";
import { locationMenuService } from "../services";

const getTags = async () => {
  const response = await locationMenuService.getTags()
  return response.data.data;
};

export default function useGetTags() {
  return useQuery("filterTags", () => getTags());
}